// extracted by mini-css-extract-plugin
module.exports = {"header":"WagWelcomeHeader_header__5eawD","logo":"WagWelcomeHeader_logo__-GuGj","logoContainer":"WagWelcomeHeader_logoContainer__1wPcM"};